// extracted by mini-css-extract-plugin
export default {"scroll":"scroll-to-top_scroll__N4HZ1"};